import React from 'react';

// Hooks
import { useMergeRefs } from 'Wpds/hooks/useMergeRefs';

// Components
import WpIcon from 'Wpds/components/icon/WpIcon';
import { WpButton, Color, Variant } from 'Wpds/components/button';
import { useTooltip, WpTooltipOverlay } from 'Wpds/components/tooltip';
import { usePopover, WpPopoverOverlay } from 'Wpds/components/popover';

// Styles
import './BaseButton.scss';

type Props = {
  onClick?: Function;
  iconPrefix?: 'fal' | 'fac' | 'fab' | 'fas';
  icon:
    | 'atom-alt'
    | 'recycle'
    | 'bullseye-arrow'
    | 'comment'
    | 'check-square'
    | 'asana'
    | 'jira'
    | 'comment-alt-check'
    | 'thumbtack'
    | 'ellipsis-h-alt'
    | 'arrow-to-right';
  count?: number;
  color?: Color;
  variant?: Variant;
  tooltip?: string;
  customDropdown?: JSX.Element;
  qaTest?: string;
};

const BaseButton = ({
  onClick,
  iconPrefix = 'fal',
  icon,
  count,
  color = 'gray',
  variant = 'tertiary',
  tooltip,
  customDropdown,
  qaTest,
}: Props) => {
  const tooltipContext = useTooltip();
  const popoverContext = usePopover({ event: 'hover', withBoxShadow: true });

  const refs = useMergeRefs([tooltipContext.targetRef, popoverContext.targetRef]);
  const handleOnClick = e => {
    onClick && onClick(e);
  };

  const baseClassName = 'BaseButton';

  return (
    <>
      <WpButton
        variant={variant}
        rounded
        icon
        color={color}
        size="xs"
        onClick={handleOnClick}
        ref={refs}
        qaTest={qaTest}
      >
        <WpIcon prefix={iconPrefix} name={icon} size="sm" />
        {count && <span className={`${baseClassName}__count`}>{count}</span>}
      </WpButton>
      {tooltip && <WpTooltipOverlay context={tooltipContext}>{tooltip}</WpTooltipOverlay>}
      {/* TODO: (@josh) - look at keeping floating element open on hover of floating element */}
      {customDropdown && <WpPopoverOverlay context={popoverContext}>{customDropdown}</WpPopoverOverlay>}
    </>
  );
};

export default BaseButton;
